import {i18n} from "../../shared/i18n";
const POSITIVE_INTEGER = /^\d+$/;
const POSITIVE_DECIMAL = /^(?:0*[1-9]\d*(?:\.\d{1,2})?|0+\.\d*[1-9]\d*)$/;

export const normalizePhoneNumber = (value) => {
    const text = String(value || "").trim();
    const digits = text.replace(/\D/g, "");
    return text.startsWith("+") && digits ? `+${digits}` : digits;
};

export const normalizePlacesCount = (value) => {
    const normalized = String(value || "").trim();
    const count = Number(normalized);
    if (!POSITIVE_INTEGER.test(normalized) || !Number.isSafeInteger(count) || count <= 0) {
        throw new Error(i18n.t("sections.club.p57"));
    }
    return count;
};

export const normalizeClubAmount = (value) => {
    const normalized = String(value || "").trim().replace(",", ".");
    if (!POSITIVE_DECIMAL.test(normalized)) {
        throw new Error(i18n.t("sections.club.p58"));
    }
    return normalized;
};

export const clubMemberLabel = (member) =>
    member?.name || member?.phone_number || `#${member?.id ?? "-"}`;

export const pageFromPaginationLink = (link, fallbackPage) => {
    if (!link) return fallbackPage;
    try {
        const url = new URL(link, window.location.origin);
        const page = Number(url.searchParams.get("page") || 1);
        return Number.isInteger(page) && page > 0 ? page : fallbackPage;
    } catch {
        return fallbackPage;
    }
};
